import React, { useState, useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Toolbar, Paper, Button, Grid, Typography } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import Input from '../../components/Input';
import DeletePopUp from '../../components/DeletePopUp';

import api from '../../services/api';
import { PermissionsContext } from '../../providers/Permissions';

export default function VehicleTypeModify() {
    const classes = useStyles();

    const {
        PermissionWrapper,
    } = useContext(PermissionsContext);

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const { id } = useParams();
    const history = useHistory();

    const [refresh, setRefresh] = useState(true)
    const [vehicleTypeValue, setVehicleTypeValue] = useState({
        name: '',
    });
    useEffect(() => {
        const loadVehicleType = async () => {
            try {
                const result = await api.get(`/vehicle_type/detail/${id}`);

                const { vehicleType } = result.data;

                setVehicleTypeValue(vehicleType);
            } catch (err) {
                setMessage({
                    open: true,
                    variant: "error",
                    text: err.error,
                });
            }
        };
        loadVehicleType();
    }, [id, history, refresh]);

    const saveVehicleType = async (values, formik) => {
        try {

            const vehicleTypeData = {
                ...values,
            };
            const result = await api.post(`/vehicle_type/modify/${id}`, vehicleTypeData);
            const { vehicleType } = result.data;

            formik.setSubmitting(false);

            setRefresh(!refresh)
            setMessage({
                open: true,
                variant: 'success',
                text: `Tipo de veículo "${vehicleType.name}" modificado com sucesso!`,
            });
        }
        catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const deleteVehicleType = async () => {
        try {
            setIsDeleting(true);

            const result = await api.delete(`/vehicle_type/delete/${id}`);

            const { deletedVehicleType } = result.data;

            setIsDeleting(false);

            if (deletedVehicleType) {
                setOpenDeletePopup(false);
                setMessage({
                    open: true,
                    variant: 'success',
                    text: `Tipo de Veículo "${deletedVehicleType.name}" deletado com sucesso!`,
                });
                history.goBack()
            }
        } catch (err) {
            setIsDeleting(false);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    }

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h5" className={classes.title}>
                            Criar Novo Tipo de Veículo
                        </Typography>
                    </Grid>
                    <Formik
                        initialValues={vehicleTypeValue}
                        enableReinitialize={true}
                        onSubmit={saveVehicleType}
                    >
                        {({ values, handleChange, handleSubmit, isSubmitting }) => (
                            <>
                                <Grid item xs={12}>
                                    <Paper alevation={3}>
                                        <form id="vehicle-type-modify" onSubmit={handleSubmit} className={classes.form}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <Grid item xs={12} className={classes.formSection}>
                                                        <Grid container xs={12} style={{
                                                            boxSizing: 'borde-box',
                                                            display: 'flex',
                                                            justifyContent: 'space-evenly',
                                                            alignItems: 'center',
                                                            flexDirection: 'column'
                                                        }}>
                                                            <Grid item
                                                                style={{
                                                                    marginBottom: '0.5%',
                                                                    width: '50%'
                                                                }}
                                                            >
                                                                <Input
                                                                    label="Nome"
                                                                    textFieldProps={{
                                                                        name: 'name',
                                                                        placeholder: 'Nome do tipo de veículo',
                                                                        onChange: handleChange,
                                                                        value: values.name,
                                                                        fullWidth: true,
                                                                        required: true,
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid container xs={8} style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-evenly',
                                                                alignItems: 'center',
                                                            }}>
                                                                <PermissionWrapper route="/tipo_de_veiculo/deletar/:id">
                                                                    <Grid item style={{
                                                                        margin: '0.5%'
                                                                    }}>
                                                                        <Button
                                                                            type="button"
                                                                            variant="contained"
                                                                            color="secondary"
                                                                            endIcon={<DeleteIcon />}
                                                                            onClick={() => setOpenDeletePopup(true)}
                                                                            id={`delete`}
                                                                        >
                                                                            Apagar tipo
                                                                        </Button>
                                                                    </Grid>
                                                                </PermissionWrapper>
                                                                <Grid item style={{
                                                                    margin: '0.5%'
                                                                }}>
                                                                    <Button
                                                                        disabled={isSubmitting}
                                                                        type="submit"
                                                                        variant="contained"
                                                                        form="vehicle-type-modify"
                                                                        color="primary"
                                                                        endIcon={<SaveIcon />}
                                                                        id={`salvar`}
                                                                    >
                                                                        {isSubmitting ? 'Salvando...' : 'Salvar tipo'}
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </Paper>
                                </Grid>
                            </>
                        )}
                    </Formik>
                </Grid>
                <DeletePopUp
                    isDelete={isDeleting}
                    title={vehicleTypeValue.name}
                    deleteFunction={() => deleteVehicleType()}
                    open={openDeletePopup}
                    setOpen={setOpenDeletePopup}
                />

                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginTop: theme.spacing(5),
    },
    title: {
        color: grey[700],
        fontSize: 28,
    },
    form: {
        padding: theme.spacing(3, 3),
    },
    formSection: {
        marginBottom: theme.spacing(3),
    },
    formSectionTitle: {
        fontWeight: 'bold',
        color: grey[700],
        marginBottom: theme.spacing(1),
    },
    removeImageButton: {
        borderRadius: 0,
        marginBottom: theme.spacing(1),
    },
}));

